import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import throttle from "./throttle";

var gsapTrigger;
{
    gsap.registerPlugin(ScrollTrigger);

    gsapTrigger = class {
        constructor(_options) {
            const defaults = {
                element: null,
                offset: {
                    top: "top-top",
                    bottom: "bottom-bottom",
                },
                callback: {
                    enter: function (_el, _dir) {},
                    leave: function (_el, _dir) {},
                },
                pointMode: false,
                once: false,
                debug: false,
            };
            const options = Object.assign({}, defaults, _options);

            this.element = options.element;
            this.offset = options.offset;
            this.callback = options.callback;
            this.pointMode = options.pointMode;
            this.once = options.once;
            this.debug = options.debug;

            this.trigger;

            this.animationScheduled = false;

            this.init();

            return this;
        }

        init() {
            var callbackEnter = this.callback.enter;
            var callbackLeave = this.callback.leave;
            var element = this.element;
            var pointMode = this.pointMode;

            this.trigger = ScrollTrigger.create({
                trigger: this.element,
                start:
                    typeof this.offset.top == "string"
                        ? this.offset.top.replace("-", " ").replace("middle", "center")
                        : this.offset.top,
                end:
                    typeof this.offset.bottom == "string"
                        ? this.offset.bottom.replace("-", " ").replace("middle", "center")
                        : this.offset.bottom,
                // Entered from top
                onEnter: function (progress, direction) {
                    callbackEnter(element, "down");
                },
                // Entered from bottom
                onEnterBack: function (progress, direction) {
                    !pointMode ? callbackEnter(element, "up") : callbackLeave(element, "up");
                },
                // Left towards bottom
                onLeave: function (progress, direction) {
                    !pointMode ? callbackLeave(element, "down") : callbackEnter(element, "down");
                },
                // Left towards top
                onLeaveBack: function (progress, direction) {
                    callbackLeave(element, "up");
                },
                markers: this.debug,
            });

            if (this.debug) {
                console.log(this);
            }
        }
    };

    window.addEventListener("resize", ScrollTrigger.refresh);

    document.addEventListener("DOMContentLoaded", function () {
        new ResizeObserver(
            throttle(function () {
                ScrollTrigger.refresh();
            }, 100)
        ).observe(document.body);
    });
}

export default gsapTrigger;
